import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addFlight } from '../redux/flight/actions';
import FrameImg from '../assets/img/icons/Frame.svg';
import Vector1 from '../assets/img/icons/Vector (1).svg';
import Vector3 from '../assets/img/icons/Vector (3).svg';

export default function FlightDataInput() {
    const dispatch = useDispatch();
    const state = useSelector((state) => state);
    const shouldDisableNewFlight = state.length >= 3;

    let [from, setFrom] = useState("");
    let [to, setTo] = useState("");
    let [journeyDate, setJourneyDate] = useState("");
    let [guestCount, setGuestCount] = useState("");
    let [flightClass, setFlightClass] = useState("");

    const handleFormSubmit = (e) => {
        e.preventDefault();

        const newFlight = {
            id: 'id-' + (new Date()).getTime(),
            from,
            to,
            journeyDate,
            guestCount,
            flightClass
        };
        dispatch(addFlight(newFlight));
    };

    return (
        <div className="mt-[160px] mx-4 md:mt-[160px] relative">
            <div className="bg-white rounded-md max-w-6xl w-full mx-auto">
                <form onSubmit={handleFormSubmit} className="first-hero lws-inputform">
                    {/* From */}
                    <div className="des-from">
                        <p>Destination From</p>
                        <div className="flex flex-row">
                        <img src={FrameImg} alt="" />
                        <select onChange={(e) => setFrom(e.target.value)} value={from} className="outline-none px-2 py-2 w-full" name="from" id="lws-from" required>
                            <option value="" hidden>Please Select</option>
                            <option value="Dhaka">Dhaka</option>
                            <option value="Sylhet">Sylhet</option>
                            <option value="Saidpur">Saidpur</option>
                            <option value="Cox's Bazar">Cox's Bazar</option>
                        </select>
                        </div>
                    </div>

                    {/* To  */}
                    <div className="des-from">
                        <p>Destination To</p>
                        <div className="flex flex-row">
                        <img src={FrameImg} alt="destination" />
                        <select onChange={(e) => setTo(e.target.value)} value={to} className="outline-none px-2 py-2 w-full" name="to" id="lws-to" required>
                            <option value="" hidden>Please Select</option>
                            <option>Dhaka</option>
                            <option>Sylhet</option>
                            <option>Saidpur</option>
                            <option>Cox's Bazar</option>
                        </select>
                        </div>
                    </div>

                    {/* Date */}
                    <div className="des-from">
                        <p>Journey Date</p>
                        <input type="date" onChange={(e) => setJourneyDate(e.target.value)} value={journeyDate} className="outline-none px-2 py-2 w-full date" name="date" id="lws-date" required />
                    </div>

                    {/* <!-- Guests --> */}
                    <div className="des-from">
                        <p>Guests</p>
                        <div className="flex flex-row">
                        <img src={Vector1} alt="" />
                        <select onChange={(e) => setGuestCount(e.target.value)} value={guestCount} className="outline-none px-2 py-2 w-full" name="guests" id="lws-guests" required>
                            <option value="" hidden>Please Select</option>
                            <option value="1">1 Person</option>
                            <option value="2">2 Persons</option>
                            <option value="3">3 Persons</option>
                            <option value="4">4 Persons</option>
                        </select>
                        </div>
                    </div>

                    {/* <!-- Class --> */}
                    <div className="des-from !border-r-0">
                        <p>Class</p>
                        <div className="flex flex-row">
                        <img src={Vector3} alt="" />
                        <select onChange={(e) => setFlightClass(e.target.value)} value={flightClass} className="outline-none px-2 py-2 w-full" name="ticketClass" id="lws-ticketClass" required>
                            <option value="" hidden>Please Select</option>
                            <option value="Business">Business</option>
                            <option value="Economy">Economy</option>
                        </select>
                        </div>
                    </div>

                    <button disabled={shouldDisableNewFlight} className="addCity" type="submit" id="lws-addCity">
                        <svg width="15px" height="15px" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                        </svg>
                        <span className="text-sm">Book</span>
                    </button>
                </form>
            </div>
        </div>
    );
}